module.exports = __webpack_public_path__ + "static/media/screenshot-02.1d85af07.jpg";